import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import { getroomType } from "../store/slices/roomType";
import ShowSkeleton from "../utils/helpers/skeleton";

const RoomTypes = () => {
  const [data, setData] = useState([]);
  const [isloading, setisLoading] = useState(false);
  const itemsPerPage = 50;
  const item = useState({ limit: itemsPerPage });
  const dispatch = useDispatch();

  useEffect(() => {
    setisLoading(true);
    getHAdminLists();
  }, []);

  const getHAdminLists = () => {
    dispatch(getroomType(item))
      .unwrap()
      .then((data) => {
        setData(data?.roomTypeData);
      })
      .catch(({ message }) => console.error(message))
      .finally(() => {
        setisLoading(false);
      });
  };

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Room Type</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/home"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Home
            </Link>
          </li>
          <li> &gt;</li>
          <li className="fw-medium">Room Type</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-header  bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3"></div>
          <Link
            to="/admin/add-roomtype"
            className="btn btn-primary text-md btn-sm px-8 py-8 radius-8 d-flex align-items-center gap-2"
          >
            Add Room Type
          </Link>
        </div>
        <div className="card-body px-24 py-2">
          <div className="table-responsive scroll-sm">
            {isloading ? (
              <Col lg={12} xs={12} md={12} align="center">
                {ShowSkeleton()}
              </Col>
            ) : (
              <table className="table striped-table mb-50">
                <thead>
                  <tr>
                    <th scope="col">
                      <div className="d-flex align-items-center gap-10">
                        S.L
                      </div>
                    </th>

                    <th scope="col">Name</th>
                    <th scope="col">Image</th>

                    <th scope="col" className="text-center">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div className="d-flex align-items-center gap-10 text-md">
                          {index + 1}
                        </div>
                      </td>

                      <td style={{ width: "300px" }}>{item?.name}</td>

                      <td>
                        <img
                          src={item.imageUrl}
                          alt=""
                          style={{ height: "50px" }}
                        />
                      </td>

                      <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          <Link
                            to={`/admin/edit-roomtype/${item._id}`}
                            className="text-md bg-warning-focus text-warning-600 bg-hover-warning-200 fw-medium w-28-px h-28-px d-flex justify-content-center align-items-center rounded-circle"
                          >
                            <Icon icon="lucide:edit" className="menu-icon" />
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default RoomTypes;
